module.exports = __webpack_public_path__ + "media/A6.a477152e.mp3";